import service from 'service';

export const getBannedWords = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/ban_word';
  return service.get(url, { params });
};

export const addBannedWord = (payload) => {
  const url = '/core_messaging/v1/ban_word';
  return service.post(url, payload);
};

export const editBannedWord = ({ uuid, ...payload }) => {
  const url = `/core_messaging/v1/ban_word/${uuid}`;
  return service.put(url, payload);
};

export const deleteBannedWord = (uuid) => {
  const url = `/core_messaging/v1/ban_word/${uuid}`;
  return service.delete(url);
};

export default {};
